import {IRule} from "@mintdata-wsp/common/controllers/spreadsheet/functions/util/text/IRule";
import {NoPaddingRule} from "@mintdata-wsp/common/controllers/spreadsheet/functions/util/text/NoPaddingRule";
import {PaddingRule} from "@mintdata-wsp/common/controllers/spreadsheet/functions/util/text/PaddingRule";

export class NumberFormatter {
    private static readonly _rules: IRule[] = [new PaddingRule(), new NoPaddingRule()];

    public static apply(number: number, format: string): string {
        const matchingRules = NumberFormatter._rules.filter((rule, __) => rule.matches(format));
        if (matchingRules.length == 0) {
            throw new Error(`Invalid format ${format}`);
        }

        if (matchingRules.length > 1) {
            throw new Error(`Ambiguous format ${format}`);
        }

        return matchingRules[0].apply(number, format);
    }
}
